<template>
  <CalendarField
    :label="
      t('sites.singleSite.financialConfig.mealPlans.form.tenders.tenderSetup.rates.startTime')
    "
    :placeholder="
      t(
        'sites.singleSite.financialConfig.mealPlans.form.tenders.tenderSetup.rates.startTimePlaceholder',
      )
    "
    :id="`tender-start-time-${index}`"
    :inputId="`tender-start-time-${index}`"
    :name="fieldName"
    timeOnly
    hourFormat="12"
    :stepMinute="15"
    :required="true"
    :baseZIndex="9999"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

// Define props
defineProps({
  fieldName: {
    type: String,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
});

// Set localization
const { t } = useI18n();
</script>
